import ResponsiveImage from '@/utils/ResponsiveImage';

interface ITile {
  isVideo: boolean;
  videoSrc?: string;
  videoThumbnail?: string;
  loop: boolean;
  controls: boolean;
  autoPlay: boolean;
  imgSrc: string;
  imgAlt: string;
  optionalHeader?: string;
  optionalLinkLabel?: string;
  optionalLinkUrl?: string;
}

interface IStorytellingTilesProps {
  tiles: ITile[];
  header?: string;
  subHeader?: string;
}

const storyTellingImage = src => [
  {
    src,
    size: { width: 171, aspectRatio: 4 / 5 },
    breakpoint: 767,
  },
  {
    src,
    size: { width: 360, aspectRatio: 4 / 5 },
    breakpoint: 768,
  },
  {
    src,
    size: { width: 676, aspectRatio: 4 / 5 },
    breakpoint: 1024,
  },
];

function Tiles({ tiles }) {
  return (
    <div className="tw-col-span-full tw-grid tw-gap-y-8 lg:tw-gap-y-10 tw-gap-x-4 lg:tw-gap-x-6 tw-grid-cols-[subgrid] md:tw-grid-cols-[subgrid] lg:tw-grid-cols-[subgrid]">
      {tiles.slice(0, 6).map((tile, idx) => (
        <div key={`storytellingTiles-tile-${idx}`} className="tw-col-span-1 md:tw-col-span-3 lg:tw-col-span-6">
          {tile.isVideo && tile.videoSrc && (
            <div>
              <video
                muted
                autoPlay={tile.autoPlay}
                loop={tile.loop}
                playsInline
                poster={tile.videoThumbnail || ''}
                className="tw-w-full tw-h-full tw-aspect-[169/180] tw-object-cover tw-mx-auto"
                preload="auto"
              >
                <source src={tile.videoSrc} type="video/mp4" />
              </video>

              <a
                href={tile.optionalLinkUrl}
                aria-label={tile.optionalLinkLabel}
                className="tw-group tw-block tw-w-full"
              >
                <h3 className="tw-mb-1 tw-inline-block">{tile.optionalHeader}</h3>
                <div className="tw-underline">{tile.optionalLinkLabel}</div>
              </a>
            </div>
          )}
          {!tile.isVideo && (
            <a
              href={tile.optionalLinkUrl}
              aria-label={
                tile.optionalLinkLabel.toLowerCase().trim() === 'shop now'
                  ? ` ${tile.optionalHeader} Shop Now`
                  : tile.optionalLinkLabel
              }
              className="tw-group tw-block tw-w-full"
            >
              {!tile.isVideo && (
                <ResponsiveImage
                  loading="lazy"
                  sources={storyTellingImage(tile.imgSrc)}
                  alt={tile.alt || tile.optionalHeader}
                  className="tw-w-full tw-h-full tw-aspect-[169/180] tw-object-cover tw-mx-auto"
                />
              )}

              <h3 className="tw-mb-1 tw-inline-block">{tile.optionalHeader}</h3>
              <div className="tw-underline">{tile.optionalLinkLabel}</div>
            </a>
          )}
        </div>
      ))}
    </div>
  );
}

export default function StoryTellingTiles({ header, subHeader, tiles }: IStorytellingTilesProps) {
  return (
    <div className="tw-mx-4 lg:tw-mx-8 min-[1472px]:tw-mx-auto tw-max-w-[1440px] lg:tw-mb-20 tw-mb-14">
      <div className="tw-grid tw-grid-cols-2 md:tw-grid-cols-6 lg:tw-grid-cols-12">
        <div id="storytelling-tiles__title" className="tw-col-span-full tw-mb-8">
          <h2 className="tw-mb-2 tw-text-center">{header}</h2>
          <p className="tw-text-center tw-mb-0">{subHeader}</p>
        </div>

        <Tiles tiles={tiles} />
      </div>
    </div>
  );
}
